import React from 'react';
import {Container, Nav, Navbar } from 'react-bootstrap';

import Banner from './../Banner/Banner'
import logo from './logo.svg'

const Header = ()=>{
	return(
		<Container fluid className="header" >
			<Navbar bg="dark" variant="dark">
				<Navbar.Brand href="#home">
					<img src={logo} alt="Creative Create Logo" height="50" width="auto" className="my-2"/>
					<h1 className="brand-title">A gift store for craft lovers</h1>
				</Navbar.Brand>
				<Nav className="d-none d-sm-flex ml-auto">
					<Nav.Link href="#shop">Shop</Nav.Link>
					<Nav.Link href="#about">About</Nav.Link>
					<Nav.Link href="#contact">Contact</Nav.Link>
				</Nav>
			</Navbar>
			<Banner />
		</Container>
	)
}

export default Header;